export const localEnvConfig = {
  DISABLED_CONSOLE_MSG: false,
  YOLO_BASE_URL: 'http://127.0.0.1:3000',
  BASE_BRANCH: 'dev',

  // CRYPTO
  APPROVED_CHAINS_IDS: [137],

  //BACKEND CONNECTION
  YOLO_API_BASE_URL: 'http://127.0.0.1:3001',
  BACKEND_SOCKET_URL: 'wss://feed-server.dev.yolorekt.finance',
  GATEWAY_SOCKET_URL: 'ws://127.0.0.1:5000',
  CONTRACTS_VERSION: '35',
}

